export default {
      id: "close-cross-small-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#close-cross-small",
      toString: function () {
        return this.url;
      }
    }